export default __webpack_public_path__ + "static/media/yahoo.1ed7700c.jpg";